import _objectSpread from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
// import mermaid from 'mermaid'
import { debounce } from 'lodash';
import { md, initClipboard } from '@/utils/markdown';
import WebQuery from '@/components/web-query.vue';
import LawQuery from '@/components/law-query.vue';
import Searching from '@/components/searching.vue';
import AiAnswerButton from './ai-answer-button.vue';
import LawDialog from '@/views/taxLaw/home/recommend-law/law-dialog.vue';
import { mapGetters } from 'vuex';
// import RecommendLaw from '@/views/taxLaw/home/recommend-law/index.vue'
import GuideQuestion from '@/views/taxLaw/home/chat/guide-question.vue';
export default {
  components: {
    GuideQuestion: GuideQuestion,
    AiAnswerButton: AiAnswerButton,
    WebQuery: WebQuery,
    LawQuery: LawQuery,
    Searching: Searching,
    LawDialog: LawDialog
  },
  props: {
    answer: {
      // 回答的答案对象
      type: Object,
      default: function _default() {
        return {
          list: []
        };
      }
    },
    question: {
      // 问题对象
      type: Object,
      default: function _default() {
        return {
          content: ''
        };
      }
    },
    showLibraryQueryTag: {
      // 是否显示知识库标签（盛瑞知识库）
      type: Boolean,
      default: true
    },
    showLawQueryTag: {
      // 是否显示法规查询标签（盛瑞法规查询）
      type: Boolean,
      default: true
    },
    showWebQueryTag: {
      // 是否显示联网查找标签（博查）
      type: Boolean,
      default: true
    },
    showEvaluate: {
      // 显示点赞/点踩
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      bgColor: '#fff',
      abortController: null,
      debounceAddEventListener: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('ai', ['aiLoading', 'qaId'])), {}, {
    // 是否PC端,如果是pc端才显示博查，小程序端不显示
    isPc: function isPc() {
      return this.$route.query.from === 'pc';
    },
    // 获取最后一条回复
    lastAnswer: function lastAnswer() {
      if (this.answer && this.answer.list && this.answer.list.length > 0) {
        return this.answer.list[this.answer.list.length - 1];
      }
      return {};
    },
    /**
     * 是否显示
     * @returns {boolean}
     */
    currentAnswerShowEvaluate: function currentAnswerShowEvaluate() {
      return !(this.answer.id === this.qaId && this.aiLoading);
    },
    /**
     * 当前AI回复是否结束
     * @returns {boolean}
     */
    currentAnswerEnd: function currentAnswerEnd() {
      return !(this.answer.id === this.qaId && this.aiLoading);
    }
  }),
  watch: {
    'lastAnswer.content': {
      handler: function handler(newValue, oldValue) {
        this.$nextTick(function () {
          // 渲染 mermaid 存在版本兼容问题，目前用9.4.0版本,暂时注释
          // mermaid.init(undefined, document.querySelectorAll('.mermaid'))
        });
      },
      immediate: true
    }
  },
  updated: function updated() {
    this.$eventBus.$emit('auto-scroll');
    // 添加监听事件
    this.debounceAddEventListener('updated');
  },
  mounted: function mounted() {
    var _this = this;
    mermaid.initialize({
      startOnLoad: true,
      securityLevel: 'loose' // 若图表含特殊字符，可放宽安全级别
    });
    // 管理监听器
    this.abortController = new AbortController();
    this.$nextTick(function () {
      initClipboard();

      // 防抖
      _this.debounceAddEventListener = debounce(_this.addEventListener, 300, {
        leading: true
      });
      _this.debounceAddEventListener('mounted');

      // 页面加载完成后强制 MathJax 渲染
      if (window.MathJax) {
        window.MathJax.typeset();
      }
    });
  },
  beforeUnmount: function beforeUnmount() {
    // 在组件销毁前调用 abort()，自动移除所有关联的事件监听器
    if (this.abortController) {
      this.abortController.abort();
      console.log('abortController.abort()');
    }
  },
  methods: {
    // 优化后的渲染函数：接收图表代码和目标元素作为参数
    renderMermaid: function renderMermaid(mermaidCode, targetElement) {
      // 生成唯一 ID（避免重复）
      var uniqueId = "mermaid-".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 8));

      // 回调函数：优先通过 error 判断是否失败
      var handleRenderResult = function handleRenderResult(error, svgCode) {
        if (error) {
          // 渲染失败：显示错误信息 + 还原原代码
          console.error('Mermaid 渲染失败：', error);
          targetElement.innerHTML = "\n        <div style=\"color: red; margin-bottom: 8px;\">\n          \u6E32\u67D3\u9519\u8BEF\uFF1A".concat(error.message, "\uFF08\u884C\u53F7\uFF1A").concat(error.line || '未知', "\uFF09\n        </div>\n        <pre style=\"background: #f5f5f5; padding: 8px; border-radius: 4px;\">").concat(mermaidCode, "</pre>\n      ");
        } else if (svgCode) {
          // 渲染成功：插入 SVG
          targetElement.innerHTML = svgCode;
          console.log('渲染成功');
        } else {
          // 边缘情况：无错误但无 SVG（极少出现）
          targetElement.innerHTML = "<pre>".concat(mermaidCode, "</pre>");
        }
      };

      // 执行渲染
      mermaid.mermaidAPI.render(uniqueId, mermaidCode, handleRenderResult);
    },
    /**
     * .markdown-render-content添加监听点击事件
     */
    addEventListener: function addEventListener(e) {
      var _this2 = this;
      if (e === 'updated') {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      var signal = this.abortController.signal;
      this.$el.querySelector('.markdown-render-content').addEventListener('click', function (event) {
        var lawUrl = event.target.getAttribute('data-law-url');
        var mermaidBtnAttr = event.target.getAttribute('data-content');
        if (lawUrl) {
          event.stopPropagation();
          event.preventDefault();
          _this2.$refs['law-dialog-ref'].handleOpen(lawUrl);
        } else if (mermaidBtnAttr) {
          console.log('复制了mermaid ->', _this2.unescapeHtml(mermaidBtnAttr));
        }
      }, {
        signal: signal
      });
    },
    unescapeHtml: function unescapeHtml(escapedStr) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = escapedStr; // 浏览器会自动解析实体，转回原始字符
      return tempDiv.textContent; // 获取解析后的纯文本
    },
    /**
     * 回答内容中只要有表格就显示特定问题
     */
    showRecommend: function showRecommend(answer) {
      var html = this.renderMarkDown(answer);
      var includeTable = html.includes('<table  style="border-collapse: collapse; width: 100%;">') && html.includes('</table>');

      // 正在输出的时候，等待输出结束后再显示推荐气泡
      if (this.answer.id === this.qaId) {
        if (!this.aiLoading) {
          return includeTable;
        } else {
          return false;
        }
      } else {
        // 不是当前输出直接判断是否显示气泡
        return includeTable;
      }
    },
    /**
     * 过滤工作流字数小于5，并且包含，"你好，您好"字眼
     * @param content
     * @returns {false|*}
     */
    filterThinkingFlow: function filterThinkingFlow(_ref) {
      var content = _ref.content;
      return content.length < 5 && (content.includes('你好') || content.includes('您好'));
    },
    /**
     * 发送
     * @param msg
     */
    sendHandler: function sendHandler(msg) {
      this.$store.dispatch('ai/setValue', {
        key: 'sendHandler',
        value: {
          send: true,
          message: msg
        }
      });
    },
    /**
     * 渲染markdown 内容
     * @param answer
     * @returns {*}
     */
    renderMarkDown: function renderMarkDown(answer) {
      var content = answer.content;
      var message = content.replaceAll('\\n', '\n');
      return md.render(message);
    }
  }
};